angular.module('property-deal')
    .component('propertyDealDiscount', {
        bindings: {
            discount: '<?',
            value: '<?'
        },
        template: `
            <span class="bold small"
                  ng-class="{ 'text-danger': $ctrl.discount.totalGross < 0, 'text-success': $ctrl.discount.totalGross > 0 }"
                  ng-if="$ctrl.discount != null"
                  uib-tooltip="Zmiana ceny: {{ $ctrl.discount.totalGross | number : 2 }}"
            >
                (<percentage value="$ctrl.discount.totalGross" total="$ctrl.value.totalGross" decimals="1" show-accurate="false"></percentage>)
            </span>
        `
    })
